module.exports = __webpack_public_path__ + "static/media/Alex.8e7a84da.png";